export const getMonthNames = (locale: string = 'en-GB'): Array<String> => {
  const months = Array.from({ length: 12 }, (v, i) => {
    const date = new Date(2020, 0, 1)
    date.setMonth(date.getMonth() + i)
    return date.toLocaleString(locale, { month: 'short' })
  })
  return months
}

export const getWeekdayNames = (
  locale: string = 'en-GB',
  formatWeekDay: string = 'long',
  firstDayOfWeek: number = 0,
): Array<String> => {
  const weekdays = Array.from({ length: 7 }, (v, i) => {
    const date = new Date('2020-01-12T00:00:00Z')
    // add timezone offset (see #1878)
    date.setMinutes(date.getMinutes() + date.getTimezoneOffset())
    date.setDate(date.getDate() + i)
    const name = date.toLocaleString(locale, { weekday: 'short' }).replace('.', '')
    return formatWeekDay === 'short' ? name[0] : name
  })
  weekdays.unshift.apply(weekdays, weekdays.splice(firstDayOfWeek))
  return weekdays
}

export const getTimeWithoutPrecision = (date: Date): number => {
  const result = new Date(date)
  result.setHours(0)
  result.setMinutes(0)
  result.setSeconds(0)
  result.setMilliseconds(0)
  return result.getTime()
}

export const isCurrentMonth = (year: number, month: number): boolean => {
  const today = new Date()
  return year === today.getFullYear() && month === today.getMonth()
}

export const getMinYear = (yearRange: number, minDate?: Date, maxDate?: Date) => {
  if (minDate) return minDate.getFullYear()
  if (maxDate) return maxDate.getFullYear() - yearRange
  return new Date().getFullYear() - yearRange / 2
}

export const getYearRange = (yearRange: number, minDate?: Date, maxDate?: Date) => {
  if (minDate && maxDate) {
    return Math.abs(maxDate.getFullYear() - minDate.getFullYear())
  }
  return yearRange
}
